import axios from "axios";
import { toast } from "react-toastify";
import {
  clientBodyaccidData,
  clientBodyaccIdData,
  userBodyDAtaa,
} from "../utils/RequestsFunction";
import {
  Ad_DirectMessageAttachmentList_Reducer,
  DirectMessageAllReducer,
  GetAllClientList_reducer,
  GetAllContacts_reducer,
  GetAllRequestComments,
  Rtk_GetAllContactPubUser,
  Rtk_GetPubUserDocsReducer,
  SignDocSaveReducer,
} from "./adityaReducer";
import {
  My_signature1,
  setConfigs_Redux,
  setJsonConfig_Redux,
  UDFClintData,
} from "./akSlice";
import {
  docuSMSApi,
  OutlookMydocusoft,
  portalClient,
  portalUser,
  PracticeServices,
} from "./AxiosInstance";
import {
  setApprovalCertificateBase64,
  setPortalMessageDocuments,
} from "./dev_chetan_slice";
import {
  fetchdocuRequestDataClient,
  fetchdocuRequestDataClientAll,
  setGetMessageAttachments_Redux,
} from "./docuSlice";

const clientBody = {
  accId: localStorage.getItem("accIdClient"),
  username: localStorage.getItem("EmailClient"),
  sPassword: localStorage.getItem("passwordClient"),
};

const userBody = {
  accid: localStorage.getItem("accid"),
  email: localStorage.getItem("Email"),
  password: localStorage.getItem("password"),
};

const userBody_2 = {
  accId: localStorage.getItem("accid"),
  email: localStorage.getItem("Email"),
  password: localStorage.getItem("password"),
};

const ArgnoclientBody = {
  agrno: localStorage.getItem("accid"),
  Email: localStorage.getItem("Email"),
  password: localStorage.getItem("password"),
};

const ArgnoPracticeBody = {
  agrno: localStorage.getItem("accIdClient"),
  Email: localStorage.getItem("EmailClient"),
  password: localStorage.getItem("passwordClient"),
};

const LoginClient = localStorage.getItem("LoginClient");

export const ApproveMessageNew_Json = (obj, callBack) => async (dispatch) => {
  try {
    let res = await portalUser.post("ApproveMessageNew_Json", obj);
    if (res) {
      let js = JSON.parse(JSON.stringify(res.data.d));
      callBack(JSON.parse(js));
    }
  } catch (error) {
    console.log(
      "Network error: No response received from server, ApproveMessageNew_Json",
      error
    );
  }
};

export const ad_RenameAttachment_Json_action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("RenameAttachment_Json", {
        ...userBody,
        ...obj,
      });
      if (res) {
        callBack(JSON.parse(res.data?.d));
      }
    } catch (error) {
      callBack(false);
      console.log(
        "Network error: No response received from server, RenameAttachment_Json",
        error
      );
    }
  };

export const ad_client_DisapproveMessageNew_Json =
  (obj, callBack) => async (dispatch) => {
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    try {
      let res = await portalUser.post("DisapproveMessageNew_Json", {
        ...clientBodyaccIdData,
        sIPAddress: ipResponse.data?.ip ? ipResponse.data?.ip : "",
        ...obj,
      });
      if (res) {
        let js = JSON.parse(JSON.stringify(res.data.d));
        toast.success("Message disapproved");
        callBack(JSON.parse(js));
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, DisapproveMessageNew_Json",
        error
      );
    }
  };

export const ad_client_ApproveMessageNew_Json =
  (obj, callBack) => async (dispatch) => {
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    try {
      let res = await portalUser.post("ApproveMessageNew_Json", {
        ...clientBodyaccIdData,
        sIPAddress: ipResponse.data?.ip ? ipResponse.data?.ip : "",
        ...obj,
      });
      if (res) {
        let js = JSON.parse(JSON.stringify(res?.data?.d));
        if (js === "") {
          callBack(true);
        } else {
          callBack(false);
        }
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, DisapproveMessageNew_Json",
        error
      );
    }
  };

export const UpdateRequestedDocStatusAction_Json_ReduxClient =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post(
        "UpdateRequestedDocStatusAction_Json",
        obj
      );
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        console.log("UpdateRequestedDocStatusAction_Json", str.d);
        callBack(str.d);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, UpdateRequestedDocStatusAction_Json",
        error
      );
    }
  };

export const GetRequestDocumentAction = (obj, callBack) => async (dispatch) => {
  if (LoginClient) {
    let body = {
      ...clientBody,
      ...obj,
    };
    try {
      let res = await portalUser.post(
        "GetPortalRequestDocumentsNew2_Json",
        body
      );
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        callBack(str.d);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetPortalRequestDocumentsNew2_Json",
        error
      );
    }
  } else {
    let body = {
      ...userBody,
      ...obj,
    };

    try {
      let res = await portalClient.post(
        "GetPortalRequestDocuments2_Json",
        body
      );
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        callBack(str.d);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetPortalRequestDocuments2_Json",
        error
      );
    }
  }
};

export const SendReminderUserAction = (obj, callBack) => async (dispatch) => {
  let body = {
    ...userBody,
    ...obj,
  };

  try {
    let res = await portalClient.post("SendReminder", body);
    if (res) {
      let str = JSON.parse(JSON.stringify(res.data));
      callBack(str.d);
    }
  } catch (error) {
    console.log(
      "Network error: No response received from server, SendReminder",
      error
    );
  }
};

export const GetCRMContactUDFValueAction =
  (obj, callBack) => async (dispatch) => {
    let body = {
      ...userBody,
      ...obj,
    };

    try {
      let res = await portalUser.post("GetCRMContactUDFValues2_Json", obj);

      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        const parseData = JSON.parse(str?.d)?.Table;
        dispatch(UDFClintData(parseData));
        callBack(parseData);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetCRMContactUDFValues2_Json",
        error
      );
    }
  };

export const UpdateUdfValuesAction = (obj, callBack) => async (dispatch) => {
  const { value, data, getOrigantryNumber } = obj;

  let body = {
    ...clientBodyaccIdData,
    projectid: data?.ProjectId,
    ClientId: getOrigantryNumber,
    ContactNo: 0,
    fieldName: data?.Name,
    fieldValue: value,
  };

  try {
    let res = await portalUser.post("UpdateContactField_Json", body);
    if (res) {
      callBack(res.data);
    }
  } catch (error) {
    console.log(
      "Network error: No response received from server, UpdateContactField_Json",
      error
    );
  }
};

export const ad_Json_GetAllContacts_Action = (callBack) => async (dispatch) => {
  try {
    let res = await portalClient.post("GetAllContacts_Json", userBody);
    if (res) {
      const newRes = JSON.parse(res.data.d);

      if (newRes) {
        dispatch(GetAllContacts_reducer(newRes));
        callBack(newRes);
      }
    }
  } catch (error) {
    console.log(
      "Network error: No response received from server, GetAllContacts_Json",
      error
    );
  }
};

export const ad_Json_GetAllClientList_Action =
  (callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("GetAllClientList_Json", userBody);
      const newRes = JSON.parse(res.data.d).Table;
      if (newRes) {
        dispatch(GetAllClientList_reducer(newRes));
        callBack(newRes);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetAllClientList_Json",
        error
      );
    }
  };

export const ad_Json_UpdateContact_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("UpdateContact_Json", {
        ...userBody,
        ...obj,
      });

      if (res.data.d) {
        callBack(res.data.d);
        return res.data.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in UpdateContact_Json --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, UpdateContact_Json",
        error
      );
    }
  };

export const ad_UpdateContactField_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("UpdateContactField_Json", {
        ...userBody,
        ...obj,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
        return res?.data?.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in UpdateContactField_Json --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, UpdateContactField_Json",
        error
      );
    }
  };

export const ad_MessageRetracted_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("MessageRetracted", {
        ...userBody,
        ...obj,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
        return res?.data?.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in MessageRetracted --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, MessageRetracted",
        error
      );
    }
  };

export const ad_MessageUnRetracted_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("MessageUnRetracted", {
        ...userBody,
        ...obj,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
        return res?.data?.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in MessageUnRetracted --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, MessageUnRetracted",
        error
      );
    }
  };

export const ad_MessageDeleted_Action = (obj, callBack) => async (dispatch) => {
  try {
    let res = await portalClient.post("MessageDeleted", {
      ...userBody,
      ...obj,
    });
    if (res?.data?.d) {
      callBack(res?.data?.d);
      toast.success("Message deleted");
      return res?.data?.d;
    } else {
      toast.error("Something went wrong");
      console.log("✌️Something went wrong in MessageDeleted --->");
    }
  } catch (error) {
    toast.error("Something went wrong");
    console.log(
      "Network error: No response received from server, MessageDeleted",
      error
    );
  }
};

export const ad_Json_GetConfiguration_Action =
  (callBack) => async (dispatch) => {
    try {
      let res = await docuSMSApi.post("Json_GetConfiguration", {
        ...ArgnoclientBody,
      });

      if (res?.data?.d) {
        let allConfigs = JSON.parse(res?.data?.d);
        callBack(allConfigs);
        dispatch(
          setJsonConfig_Redux({
            bussiness: allConfigs.Table1,
            sources: allConfigs.Table2,
            mangers: allConfigs.Table3,
            companyStatus: allConfigs.Table,
          })
        );
        dispatch(
          setConfigs_Redux({
            roles: allConfigs?.Table4,
            managers: allConfigs?.Table3,
          })
        );
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in Json_GetConfiguration --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, Json_GetConfiguration",
        error
      );
    }
  };

export const getMessagerequest = (obj, callBack) => async (dispatch) => {
  if (LoginClient) {
    try {
      let res = await portalUser.post("GetAllComments_Json", {
        ...clientBodyaccidData,
        ...obj,
      });
      if (res?.data?.d) {
        if (res?.data?.d === "False") return;
        callBack(res?.data?.d);
        dispatch(GetAllRequestComments(JSON.parse(res?.data?.d)));
        return res?.data?.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in GetAllComments_Json --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, GetAllComments_Json",
        error
      );
    }
  } else {
    try {
      let res = await portalClient.post("GetAllComments_Json", {
        ...userBody,
        ...obj,
      });
      if (res?.data) {
        callBack(res?.data?.d);
        dispatch(GetAllRequestComments(JSON.parse(res?.data?.d)));
        return res?.data?.d;
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in GetAllComments_Json --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, GetAllComments_Json",
        error
      );
    }
  }
};

export const addCommentClientrequest = (obj, callBack) => async (dispatch) => {
  try {
    let res = await portalUser.post("CommentAddedNew_Json", {
      ...clientBodyaccidData,
      ...obj,
    });
    if (res?.data) {
      callBack(res?.data);
      toast.success("Comment added successfully!!");
      // return res?.data?.d;
    } else {
      toast.error("Something went wrong");
      console.log("✌️Something went wrong in CommentAddedNew_Json --->");
    }
  } catch (error) {
    toast.error("Something went wrong");
    console.log(
      "Network error: No response received from server, CommentAddedNew_Json",
      error
    );
  }
};

export const requestDocumentStatusAction =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("GetDocumentStatus_Json", {
        ...userBody,
        ...obj,
        messageEmailAddress: "",
      });
      if (res?.data?.d) {
        callBack(JSON.parse(res?.data?.d));
        return JSON.parse(res?.data?.d);
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in GetDocumentStatus_Json --->");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(
        "Network error: No response received from server, GetDocumentStatus_Json",
        error
      );
    }
  };

export const ad_Json_GetClientCardDetails_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_GetClientCardDetails", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(JSON.parse(res?.data?.d));
      } else {
        return console.log(
          "✌️Something went wrong in Json_GetClientCardDetails --->"
        );
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetClientCardDetails",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetClientAssignedUnassignedFolderList_Action =
  (obj, callBack) => async (dispatch) => {
    let body = {
      agrno: ArgnoclientBody.agrno,
      UserEmail: ArgnoclientBody.Email,
      password: ArgnoclientBody.password,
      ...obj,
      intuserId: localStorage.getItem("UserId"),
    };
    try {
      let res = await PracticeServices.post(
        "Json_GetClientAssignedUnassignedFolderList",
        body
      );
      if (res?.data?.d) {
        callBack(JSON.parse(res?.data?.d));
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in ad_Json_GetClientAssignedUnassignedFolderList_Action --->"
        );
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, ad_Json_GetClientAssignedUnassignedFolderList_Action",
        error?.response?.data
      );
    }
  };

export const ad_Json_UpdateClient_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_UpdateClient", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");
      console.log("✌️Something went wrong in Json_UpdateClient--->");

      console.log(
        "Network error: No response received from server, Json_UpdateClient",
        error?.response?.data
      );
    }
  };

export const ad_AddFolders_Toclient_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_AssignProjectsToClient", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");
      console.log("✌️Something went wrong in Json_AssignProjectsToClient --->");

      console.log(
        "Network error: No response received from server, Json_AssignProjectsToClient",
        error?.response?.data
      );
    }
  };

export const ad_ClientAddress_Update_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_SetClientAddress", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");
      console.log("✌️Something went wrong in Json_SetClientAddress --->");

      console.log(
        "Network error: No response received from server, Json_SetClientAddress",
        error?.response?.data
      );
    }
  };

export const ad_Json_CRMSaveUDFValues_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_CRMSaveUDFValues", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in Json_CRMSaveUDFValues --->");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_CRMSaveUDFValues",
        error?.response?.data
      );
    }
  };

export const GetSignatureDocumentAction =
  (obj, callBack) => async (dispatch) => {
    if (LoginClient) {
      let body = {
        ...clientBody,
        ...obj,
      };
      try {
        let res = await portalUser.post(
          "GetPortalRequestDocumentsNew2_Json",
          body
        );
        if (res) {
          let str = JSON.parse(JSON.stringify(res.data.d));
          dispatch(SignDocSaveReducer(str));
          callBack(str.d);
        }
      } catch (error) {
        console.log(
          "Network error: No response received from server, GetPortalRequestDocumentsNew2_Json",
          error
        );
      }
    } else {
      let body = {
        ...userBody,
        ...obj,
      };

      try {
        let res = await portalClient.post(
          "GetPortalRequestDocuments2_Json",
          body
        );
        if (res) {
          let str = JSON.parse(JSON.stringify(res.data));
          callBack(str.d);
        }
      } catch (error) {
        console.log(
          "Network error: No response received from server, GetPortalRequestDocuments2_Json",
          error
        );
      }
    }
  };

export const ad_SetPubUserSign_Json_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("SetPubUserSign_Json", {
        ...clientBodyaccidData,
        ...body,
      });
      if (res?.data) {
        callBack(res?.data);
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in SetPubUserSign_Json --->");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");
      callBack(false);
      console.log(
        "Network error: No response received from server, SetPubUserSign_Json",
        error?.response?.data
      );
    }
  };

export const ad_Json_deleteSupplierContact_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("DeleteSupplierContact_Json", {
        ...userBodyDAtaa,
        ...body,
      });
      if (res?.data) {
        callBack(res?.data);
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in DeleteSupplierContact_Json --->"
        );
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, DeleteSupplierContact_Json",
        error?.response?.data
      );
    }
  };

export const ad_DeleteClient_Json_DeleteSuppliers_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("DeleteSuppliers_Json", {
        ...userBodyDAtaa,
        ...body,
      });
      if (res?.data) {
        callBack(res?.data);
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in DeleteSuppliers_Json --->");
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, DeleteSuppliers_Json",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetCRMContactUDFValues_Action =
  (body, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_GetCRMContactUDFValues", {
        ...ArgnoclientBody,
        ...body,
      });
      if (res?.data?.d) {
        callBack(JSON.parse(res?.data?.d));
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in Json_GetCRMContactUDFValues --->"
        );
      }
    } catch (error) {
      if (error?.response.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetCRMContactUDFValues",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetWebTemplates_Action =
  (callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_GetWebTemplates", {
        ...ArgnoclientBody,
      });
      if (res?.data?.d) {
        callBack(JSON.parse(res?.data?.d));
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in Json_GetWebTemplates --->");
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetWebTemplates",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetStandardLetterData_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await OutlookMydocusoft.post("Json_GetStandardLetterData", {
        ...ArgnoclientBody,
        ...obj,
        UserEmail: ArgnoclientBody?.Email,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        callBack(false);
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in Json_GetStandardLetterData --->"
        );
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetStandardLetterData",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetHtmlFromRtf_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await OutlookMydocusoft.post("Json_GetHtmlFromRtf", {
        ...ArgnoclientBody,
        ...obj,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in Json_GetHtmlFromRtf --->");
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetHtmlFromRtf",
        error?.response?.data
      );
    }
  };

export const ad_UpdatePortalDocTemplateName_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("UpdatePortalDocTemplateName_Json", {
        ...userBody_2,
        ...obj,
      });
      if (res?.data?.d) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in UpdatePortalDocTemplateName_Json --->"
        );
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, UpdatePortalDocTemplateName_Json",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetOnboardingDetailsByMultipleClientIdPubUser_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post(
        "Json_GetOnboardingDetailsByMultipleClientIdPubUser",
        {
          ...ArgnoPracticeBody,
          ...obj,
        }
      );
      if (res?.data) {
        // console.log('✌️res?.data --->', res?.data);
        callBack(JSON.parse(res?.data?.d)[0]);
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in Json_GetOnboardingDetailsByMultipleClientIdPubUser --->"
        );
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetOnboardingDetailsByMultipleClientIdPubUser",
        error?.response?.data
      );
    }
  };

export const GetOnboardingDetailsByMultipleClientIdPubUser =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post(
        "Json_GetOnboardingDetailsByMultipleClientIdPubUser",
        obj
      );

      res = res.data.d;

      console.log(
        "GetOnboardingDetailsByMultipleClientIdPubUser",
        JSON.parse(res)
      );

      callBack(JSON.parse(res));
    } catch (error) {
      console.log(
        "Network error: No response received from server, Json_GetOnboardingDetailsByMultipleClientIdPubUser",
        error
      );
    }
  };

export const ad_Json_GetPortalMessageDetailsByTaskIdPubUser_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post(
        "Json_GetPortalMessageDetailsByTaskIdPubUser",
        {
          ...ArgnoPracticeBody,
          ...obj,
        }
      );
      if (res?.data) {
        // console.log("✌️res?.data?.d --->", res?.data);
        callBack(JSON.parse(res?.data?.d)?.Table[0]);
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in Json_GetPortalMessageDetailsByTaskIdPubUser --->"
        );
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_GetPortalMessageDetailsByTaskIdPubUser",
        error?.response?.data
      );
    }
  };

export const ad_Json_ToGetEngagementTaskID_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_ToGetEngagementTaskID", {
        ...ArgnoPracticeBody,
        ...obj,
      });
      if (res?.data) {
        callBack(res?.data?.d);
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in Json_ToGetEngagementTaskID --->"
        );
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_ToGetEngagementTaskID",
        error?.response?.data
      );
    }
  };

export const ad_Json_CompanyHouseDetails_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await PracticeServices.post("Json_CompanyHouseDetails", {
        ...obj,
      });
      if (res?.data?.d) {
        const str = JSON.parse(JSON.stringify(res?.data?.d));
        callBack(JSON.parse(str));
      } else {
        callBack(false);
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in Json_CompanyHouseDetails --->");
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, Json_CompanyHouseDetails",
        error?.response?.data
      );
    }
  };

export const ad_SendReminderByMsgId_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("SendReminderByMsgId_Json", {
        ...userBody,
        ...obj,
      });
      if (res?.data) {
        callBack(res?.data);
        toast.success("Sent message reminder");
      } else {
        toast.error("Something went wrong");
        console.log("✌️Something went wrong in SendReminderByMsgId_Json --->");
      }
    } catch (error) {
      if (error?.response?.data?.Message)
        toast.error(error?.response?.data?.Message);
      else toast.error("Something went wrong");

      console.log(
        "Network error: No response received from server, SendReminderByMsgId_Json",
        error?.response?.data
      );
    }
  };

export const ad_SendMultiReminderEmail_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("SendMultiReminderEmail_Json", {
        ...userBody,
        portalDocId: obj,
      });
      if (res?.data) {
        console.log("✌️res?.data --SendMultiReminderEmail_Json->", res?.data);
        callBack(res?.data?.d);
        toast.success("Sent message reminder");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log("✌️error?.response --->", error);

      console.log(
        "Network error: No response received from server, SendMultiReminderEmail_Json",
        error?.response?.data
      );
    }
  };

export const ad_GetMultiReminderStatus_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalClient.post("GetMultiReminderStatus_Json", {
        ...userBody,
        taskId: obj,
      });
      if (res?.data) {
        callBack(JSON.parse(res?.data?.d));
      } else {
        toast.error("Something went wrong");
        console.log(
          "✌️Something went wrong in GetMultiReminderStatus_Json --->"
        );
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetMultiReminderStatus_Json",
        error?.response?.data
      );
    }
  };

export const ad_Json_GetUserItemDetailsByCCodeByPubUser_action =
  (ClientId) => async (dispatch) => {
    const payload = {
      Email: localStorage.getItem("EmailClient"),
      password: localStorage.getItem("passwordClient"),
      agrno: localStorage.getItem("accIdClient"),
      UserId: 0,
      EmailID: localStorage.getItem("EmailClient"),
      itemID: "",
      ProjectId: 15,
      ClientId: ClientId ? ClientId : "",
      sectionId: -1,
    };
    try {
      const response = await PracticeServices.post(
        "Json_GetUserItemDetailsByCCodeByPubUser",
        payload
      );
      const data = JSON.parse(response?.data?.d);
      dispatch(Rtk_GetPubUserDocsReducer(data));
      return data;
    } catch (error) {
      console.log(error, "Error in Json_GetUserItemDetailsByCCodeByPubUser");
    }
  };

export const ad_GetAllContactsByCCode_Json = (payload) => async (dispatch) => {
  try {
    const response = await portalUser.post(
      "GetAllContactsByCCode_Json",
      payload
    );
    const data = JSON.parse(response?.data?.d);
    dispatch(Rtk_GetAllContactPubUser(data));
    return data;
  } catch (error) {
    console.log(error, "Error in Json_GetUserItemDetailsByCCodeByPubUser");
  }
};

export const ad_RegisterItem_Json_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await portalClient.post("RegisterItem_Json", {
        ...userBody,
        ...payload,
      });
      const data = JSON.parse(response?.data?.d);
      callBack(data);
    } catch (error) {
      console.log(error, "Error in Json_GetUserItemDetailsByCCodeByPubUser");
    }
  };

export const ad_GetPortalUserDetails_Json_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await portalClient.post("GetPortalUserDetails_Json", {
        ...userBody_2,
        contactEmail: "gethaudadayyyyyydaa@gmail.com",
        contactName: "Ajay Mandloi",
        asPropertyGrid: true,
      });
      const data = JSON.parse(response?.data?.d);
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

export const downloadAllDoc = () => {};

export const ad_DownloadAllDoc_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await portalClient.post(
        "GetLatestAttachmentsAsZip_Json",
        {
          ...userBody,
          messageID: payload,
          filter: "",
        }
      );
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

// company Notes APIs

export const ad_GetAll_Notes_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post("Json_Get_All_DS_Notes", {
        ...ArgnoclientBody,
        OriginatorNo: payload,
      });
      const data = response?.data?.d;
      if (data) {
        callBack(JSON.parse(data)?.Table);
      } else {
        callBack(false);
      }
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
      callBack(false);
    }
  };

export const ad_Add_Notes_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post("Json_DS_NotesSave", {
        ...ArgnoclientBody,
        ...payload,
      });
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

export const ad_Create_Notes_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post("Json_DS_NotesAdd", {
        ...ArgnoclientBody,
        ...payload,
      });
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

export const ad_Update_Notes_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post(
        "Json_DS_UpdateNotesDetail",
        {
          ...ArgnoclientBody,
          ...payload,
        }
      );
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };
// delete Note
export const ad_Delete_Notes_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post("Json_DS_NotesDelete", {
        ...ArgnoclientBody,
        ...payload,
      });
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

export const ad_Get_Notes_Description_byNoteID_inCompany_Action =
  (payload, callBack) => async (dispatch) => {
    try {
      const response = await PracticeServices.post("Json_Get_DS_NotesById", {
        ...ArgnoclientBody,
        ...payload,
      });
      const data = response?.data?.d;
      callBack(data);
    } catch (error) {
      console.log(error, "Error in ad_GetPortalUserDetails_Json_Action");
    }
  };

// d-message-viewer API

export const Dmessage_GetAllDetailsByMessageId_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("GetAllDetailsByMessageId_Json", obj);
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        const parseData = JSON.parse(res.data?.d);
        const manageData = {
          Message: { ...parseData.Message[0] },
          PortalUsersInbox: { ...parseData.PortalUsersInbox[0] },
        };
        dispatch(DirectMessageAllReducer(manageData));
        callBack(manageData);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetAllDetailsByMessageId_Json",
        error
      );
    }
  };

export const Dmessage_MarkMessageAsViewedByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    try {
      let res = await portalUser.post("MarkMessageAsViewedByToken_Json", {
        ...obj,
        ipAddress: ipResponse.data?.ip ? ipResponse.data?.ip : "",
      });
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        callBack(str);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, MarkMessageAsViewedByToken_Json",
        error
      );
    }
  };

export const Dmessage_GetApprovalsAndCommentsHtmlByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post(
        "GetApprovalsAndCommentsHtmlByToken_Json",
        obj
      );
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        callBack(str.d);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetApprovalsAndCommentsHtmlByToken_Json",
        error
      );
    }
  };

export const Dmessage_GetCertificateNewByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("GetCertificateNewByToken_Json", obj);
      console.log("✌️res --->", res);
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        dispatch(setApprovalCertificateBase64(JSON.parse(str?.d)));
        callBack(str.d);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetCertificateNewByToken_Json",
        error
      );
    }
  };

export const Dmessage_GetAllCommentsByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("GetAllCommentsByToken_Json", obj);
      if (res) {
        // console.log("✌️res.data --->", res.data);

        let str = JSON.parse(JSON.stringify(res.data));
        dispatch(GetAllRequestComments(JSON.parse(str?.d).Table));
        callBack(JSON.parse(str?.d).Table);
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetAllCommentsByToken_Json",
        error
      );
    }
  };

export const Dmessage_GetMessageDocumentsByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("GetMessageDocumentsByToken_Json", obj);
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        let str2 = JSON.parse(str?.d)?.MessageDocuments;
        callBack(str2);
        dispatch(Ad_DirectMessageAttachmentList_Reducer(str2));
        // dispatch(setGetMessageAttachments_Redux(str2));
        dispatch(setPortalMessageDocuments(str2));
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetMessageDocumentsByToken_Json",
        error
      );
    }
  };

export const Dmessage_CommentAddedByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("CommentAddedByToken_Json", obj);
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        let str2 = JSON.parse(str?.d);
        callBack(str2);
        dispatch(Ad_DirectMessageAttachmentList_Reducer(str2));
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, CommentAddedByToken_Json",
        error
      );
    }
  };

export const Dmessage_PortalUsersRequestedDocs2NewByToken_Json_Action =
  (cusTomerEmail) => async (dispatch) => {
    let body = {
      accid: cusTomerEmail?.accid,
      token: cusTomerEmail?.token,
      messageID: cusTomerEmail?.messageId,
      template: "x",
      filterBy: "All",
    };
    try {
      let res = await portalUser.post(
        "PortalUsersRequestedDocs2NewByToken_Json",
        body
      );

      if (res && res.data) {
        let str = res.data;
        let parsedData = typeof str.d === "string" ? JSON.parse(str.d) : str.d;

        const arrayUniqueByKey = [
          ...new Map(
            parsedData.map((item) => [item["TemplateName"], item])
          ).values(),
        ];
        dispatch(fetchdocuRequestDataClient(arrayUniqueByKey));
        dispatch(fetchdocuRequestDataClientAll(parsedData));
        return parsedData;
      }
    } catch (error) {
      console.error(
        "Network error: No response received from server, PortalUsersRequestedDocs2NewByToken_Json",
        error
      );
    }
  };

export const Dmessage_Download_DocumnetReq_Document_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post(
        "GetPortalRequestDocumentsNew2ByToken_Json",
        obj
      );
      if (res) {
        let str = JSON.parse(JSON.stringify(res.data));
        let str2 = JSON.parse(str?.d);
        callBack(str2);
        dispatch(Ad_DirectMessageAttachmentList_Reducer(str2));
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetPortalRequestDocumentsNew2ByToken_Json",
        error
      );
    }
  };

export const Dmessage_Get_Sign_Action =
  (clientBodyaccidData) => async (dispatch) => {
    try {
      let res = await portalUser.post(
        "/GetPubUserSignatureByToken_Json",
        clientBodyaccidData
      );

      dispatch(
        My_signature1({
          signature: JSON.parse(res.data.d),
        })
      );
    } catch (error) {
      console.log(
        "Network error: No response received from server, GetUsersEmailSignature_Json",
        error
      );
    }
  };

export const Dmessage_Poral_Document_Sign_Action =
  (obj, callBack) => async (dispatch) => {
    try {
      let res = await portalUser.post("SetPubUserSignByToken_Json", obj);
      if (res?.data?.d && res?.data) {
      }
      callBack(true);
    } catch (error) {
      callBack(false);
      console.log(
        "Network error: No response received from server, SetPubUserSignByToken_Json",
        error
      );
    }
  };

export const Dmessage_ApproveMessageNewByToken_Json_Action =
  (obj, callBack) => async (dispatch) => {
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    try {
      let res = await portalUser.post("ApproveMessageNewByToken_Json", {
        sIPAddress: ipResponse.data?.ip ? ipResponse.data?.ip : "",
        ...obj,
      });
      if (res) {
        let js = JSON.parse(res?.data?.d);
        if (js) {
          callBack(false);
        } else {
          callBack(true);
        }
      }
    } catch (error) {
      console.log(
        "Network error: No response received from server, DisapproveMessageNew_Json",
        error
      );
    }
  };

// d-message-viewer API
